import React from 'react';
import { Form, Input } from 'antd';
import './CustomerPasswordInput.scss';
import { ReactComponent as Hide } from '../../../../resources/images/svg/hide.svg';
import { ReactComponent as Visible } from '../../../../resources/images/svg/visible.svg';

function CustomerPasswordInput({
  className, name, label, errorMessage, rules = [],
}) {
  const renderPasswordIcon = (visible) => {
    if (visible) return <Visible />;
    return <Hide />;
  };
  return (
    <Form.Item rules={rules} className={`customer-password-input ${className}`} name={name} label={label} help={errorMessage} validateStatus={errorMessage && 'error'}>
      <Input.Password iconRender={renderPasswordIcon} />
    </Form.Item>
  );
}

export default CustomerPasswordInput;
